module.exports = __webpack_public_path__ + "static/media/scm-logo.5b1162ed.svg";